/** Query key for the asset inventory's default multi-level order. */
export const ASSET_INVENTORY_SORT_KEY = 'inventoryOrder';

/**
 * AssetGroup.category sequence for the asset list.
 * Ağ ve Sistemler, Uygulamalar, Taşınabilir Cihazlar ve Ortam, then the rest.
 */
export const ASSET_GROUP_CATEGORY_ORDER = Object.freeze([
    'network_systems',
    'applications',
    'portable_devices',
    'iot_devices',
    'physical_space',
    'staff',
    'other',
]);
